import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom'
import { RootState } from '@/store';

const RequireAuth: React.FC<RequireAuthProps> = (
  {
    children,
    access
  }
) => {
  const authState = useSelector((state: RootState) => state.auth);
  const menuList = window.localStorage.getItem('menu_list')
  const location = useLocation()

  if (menuList?.includes(access)) {
    return children
  }
  if (authState?.access_token) {
    return (
      <Navigate
        to='/dashboard/not-authorized'
        state={{ from: location }}
        replace />
    )
  }
  return (
    <Navigate
      to='/login'
      state={{ from: location }}
      replace />
  )
}


export default RequireAuth
